import { StateParams } from "@uirouter/angularjs";
import {SensorService} from "../services/SensorService";
import {SensorStatService} from "../services/SensorStatService";

export class AssetSensorHistoriesDirective implements ng.IDirective {
    restrict= 'AEC';
    transclude = true;
    template = require('../../views/assetsensorhistories.html').default;
    public static $inject = ['$location', 'CustomFieldNameModel'];
    constructor(public stateParamsService:StateParams, public modal:angular.ui.bootstrap.IModalService,
                public sensorService:SensorService, public sensorstatService:SensorStatService) {

    }
    controller = ()=>{
    }

    static factory():ng.IDirectiveFactory {
        var directive = (stateParamsService:StateParams, modal:angular.ui.bootstrap.IModalService,
                         sensorService:SensorService, sensorstatService:SensorStatService) => {
            return new AssetSensorHistoriesDirective(stateParamsService, modal, sensorService, sensorstatService);
        }
        directive.$inject = ['$location', 'CustomFieldNameModel'];
        return directive;
    }
}
